import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { User } from '@/store/user/user.model';
import { UserGetter } from '@/store/user/user.module';
import { Assignment, UserAssignment } from '@/store/assignment/assignment.model';
import { AssignmentGetter } from '@/store/assignment/assignment.module';
import AssignmentFormComponent from './assignmentForm/AssignmentForm.vue';

export default defineComponent({
  name: 'AssignmentTableComponent',
  components: {
    AssignmentFormComponent,
  },
  props: {
    mode: {
      type: [String as () => 'ผู้แทน ร.นรม./รมต.นร' | 'ผู้ช่วยผู้ตรวจราชการ' | 'เจ้าหน้าที่ประจำจังหวัด'],
      default: () => 'เจ้าหน้าที่ประจำจังหวัด',
    },
  },
  setup: (props) => {
    const userGetter = props.mode != 'เจ้าหน้าที่ประจำจังหวัด'
      ? props.mode == 'ผู้แทน ร.นรม./รมต.นร'
        ? UserGetter.MINISTER
        : UserGetter.REGION
      : UserGetter.PROVINCE;

    const store = useStore();
    const users = computed<User[]>(() => store.getters[userGetter]);
    const assignments = computed<Assignment[]>(() => store.getters[AssignmentGetter.ALL]);
    const userAssignments = computed<UserAssignment[]>(() => users.value.map(m => CreateUserAssignment(m)));
    const assignmentForm = ref<InstanceType<typeof AssignmentFormComponent>>();
    const selectedUser = ref<{id: string, name: string, assignmentItems: number[]}>();
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      initialDataTable();
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
      };

    const CreateUserAssignment = (user: User) => {
      return {
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
        roles: user.roles,
        assignments: assignments.value.filter(m => m.userId === user.id)
          .map(m => m.assignments)
          .flat()
      } as UserAssignment;
    };

    const selectedClick = (id: string) => {
      new Promise<void>((resolve) => {
        const user = userAssignments.value.find(m => m.id === id) as UserAssignment;
        selectedUser.value = {
          id: user.id,
          name: user.name,
          assignmentItems: user.assignments.map(m => m.id)
        };
        resolve();
      }).then(() => assignmentForm.value?.show());
    };

    return {
      userAssignments,
      selectedUser,
      assignmentForm,
      datatable,
      selectedClick,
    };
  },
});
